<template>
  <span>
    <v-row v-for="card in cards" :key="card.ref" dense justify="center">
      <v-col>
        <v-card-charts-dashboard
          :title="card.title"
          :ref="card.ref"
          :chart-ref="card.ref"
          :options="card.options"
          :deepCopyOnUpdate="card.deepCopyOnUpdate"
          :isLoading="card.loading"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  name: "DashboardLnoVisaoAneelGraficos",
  components: {
    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped></style>
